<template>
  <div>
    <add-receiving-country
      :country_id="country_id"
      :is-active.sync="isAdding"
      @added="countryAdded"
    />

    <data-table
      title="Receiving Countries"
      :url="url"
      :headers="headers"
      :fields="fields"
      ref="table"
      searchable
      @click:row="showDetails"
      @rowClicked="showDetails"
    >
      <template slot="action.icons">
        <v-btn color="primary" @click="isAdding = true">
          <v-icon color="light-blue lighten-4">
            mdi-plus-outline
          </v-icon>
          Add Receiving Country
        </v-btn>
      </template>
      <template slot="item.receiving_country.is_sending_country" slot-scope="{ item }">
        <v-icon color="success" v-if="item.receiving_country.is_sending_country">
          mdi-progress-check
        </v-icon>
        <v-icon color="error" v-else>
          mdi-progress-close
        </v-icon>
      </template>
      <template slot="item.actions" slot-scope="{ item }">
        <v-icon medium title="Delete Country" @click.stop="deleteItem(item)">
          mdi-delete
        </v-icon>
      </template>
    </data-table>
  </div>
</template>

<script>
import AddReceivingCountry from "./new";

export default {
  props: { country_id: { required: true, type: [Number, String] } },
  components: { AddReceivingCountry },
  data() {
    return {
      isAdding: false,
      dialogDelete: false,
      headers: {
        "receiving_country.name": "Name",
        "receiving_country.sending_min_amount": "Sending Min Amount",
        "receiving_country.sending_max_amount": "Sending Max Amount",
        "receiving_country.receiving_min_amount": "Receiving Min Amount",
        "receiving_country.receiving_max_amount": "Receiving Max Amount",
        "receiving_country.is_sending_country": "Is Sending Country",
        actions: "Actions",
      },
      fields: {
        sending_min_amount: {
          format: (value) => {
            return `€ ${this.asCurrency(value)}`;
          },
        },
        sending_max_amount: {
          format: (value) => {
            return `€ ${this.asCurrency(value)}`;
          },
        },
        receiving_min_amount: {
          format: (value) => {
            return `€ ${this.asCurrency(value)}`;
          },
        },
        receiving_max_amount: {
          format: (value) => {
            return `€ ${this.asCurrency(value)}`;
          },
        },
      },
    };
  },
  watch: {
    url() {
      this.$nextTick(() => {
        this.$refs.table.fetchData();
      });
    },
  },
  computed: {
    url() {
      return `/api/v1/transactions/transferCountries/${this.country_id}/receivingCountries`;
    },
  },
  methods: {
    countryAdded({ message }) {
      this.isAdding = false;
      Notify.success(message);
      // refresh the table data
      this.$refs.table.fetchData();
    },
    showDetails({ id }) {
      this.$router.push({ name: "platform.receivingCountries.show", params: { id } });
    },
    deleteItem(item) {
      Notify.confirm(`The receiving country will be removed.`).then(() => {
        this.$http
          .delete(
            `/api/v1/transactions/transferCountries/${this.country_id}/receivingCountries/${item.id}`,
          )
          .then(() => {
            Notify.success("Receiving country was successfully deleted.");
            // refresh the table data
            this.$refs.table.fetchData();
          });
      });
    },
  },
};
</script>
